import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { ColliUser, ColliUserListResponse, ColliUserQueryParams, CreateColliUser } from '@frontend/colli/types';

export class ColliUserClient extends APIClient {
    public static readonly endpoint = '/colli-api/v1';

    public static async fetchColliUsers(queryParams?: ApiQueryParams<ColliUserQueryParams>): Promise<ColliUserListResponse> {
        return await this.apiPaginated<ColliUserListResponse, ColliUserQueryParams>(`${this.endpoint}/users`, queryParams);
    }

    public static async postColliUser(
        accountId: string,
        transactionId: string,
        colliId: string,
        createColliUser: CreateColliUser
    ): Promise<ColliUser> {
        const response = await this.post(
            `${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/collis/${colliId}/users`,
            createColliUser
        );
        return await this.handleResponse<ColliUser>(response);
    }

    public static async fetchColliUser(accountId: string, transactionId: string, colliId: string, userId: string): Promise<ColliUser> {
        const response = await this.fetch(
            `${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/collis/${colliId}/users/${userId}`
        );
        return await this.handleResponse<ColliUser>(response);
    }

    public static async deleteColliUser(accountId: string, transactionId: string, colliId: string, userId: string): Promise<void> {
        const response = await this.delete(
            `${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/collis/${colliId}/users/${userId}`
        );
        return await this.handleVoidResponse(response);
    }
}
